import {FieldsForm} from '../../../../fields'
import {MixConfiguration, MixForm} from '../../../../fields/mix/types'
import {ContractDto, MaterialDto} from '../../../../options/contract.types'
import {OrderDto} from '../../../types'
import {CreateFormInput} from '../types'

export const buildMixForm = ({
  order,
  configuration: {
    mix: {contracts}
  }
}: CreateFormInput<MixConfiguration>): MixForm => {
  const contractData = pickContractForOrder(contracts, order)

  if (!contractData) {
    const lineItem = order.lineItems[0]
    return {
      material: {
        materialId: null,
        materialNumber: lineItem.materialNumber,
        materialDescription: lineItem.materialDescription,
        customerMaterialDescription: lineItem.customerMaterialDescription || null
      },
      contract: undefined,
      materialVariations: undefined
    }
  }

  const {contract, material} = contractData

  return {
    material: {
      materialId: material.materialId,
      materialNumber: material.materialNumber,
      materialDescription: material.materialDescription,
      customerMaterialDescription: material.customerMaterialDescription || null
    },
    materialVariations: buildMaterialVariationsForm(order, material),
    contract: {
      contractNumber: contract.contractNumber,
      contractItemPositionNumber: material.contractItemPositionNumber
    }
  }
}

const pickContractForOrder = (contracts: ContractDto[], order: OrderDto) => {
  const removeLeadingZeros = (s: string | undefined): string | undefined => s?.replace(/^0+/, '')
  const contract = contracts.find(
    (c) => removeLeadingZeros(c.contractNumber) === removeLeadingZeros(order.contractNumber)
  )

  if (!contract) {
    return undefined
  }

  const material = contract.materials.find(
    (m) =>
      removeLeadingZeros(m.contractItemPositionNumber) === removeLeadingZeros(order.contractItem)
  )

  if (!material) {
    return undefined
  }

  return {
    contract,
    material
  }
}

const buildMaterialVariationsForm = (
  order: OrderDto,
  material: MaterialDto
): FieldsForm['materialVariations'] => {
  const lineItem = order.lineItems[0]
  const isBaseMaterial = material.materialNumber === lineItem.materialNumber
  if (!material.materialVariations || isBaseMaterial) {
    return undefined
  }

  const materialAttributes = lineItem.materialAttributes || []
  const slump = materialAttributes.find((attr) => attr.key === 'Slump')?.value
  const setControl = materialAttributes.find((attr) => attr.key === 'SetControl')?.value
  if (!slump && !setControl) {
    return undefined
  }

  const contractSlump = material.materialVariations.slumps.find((s) => s.value === slump)
  const contractSetControl = material.materialVariations.setControls.find(
    (s) => s.value === setControl
  )
  if (!contractSlump && !contractSetControl) {
    return undefined
  }

  return {
    slump: contractSlump ?? null,
    setControl: contractSetControl ?? null
  }
}
